import type { ProductCard, ProductStatus } from "@itaas/pep-contracts";

/** Produit pas encore commercialisable — liste d'attente / early access. */
export function isPrelaunchProduct(status: ProductStatus): boolean {
  return status === "planned" || status === "reserved" || status === "alpha";
}

export function filterPrelaunchProducts(products: ProductCard[]): ProductCard[] {
  return products.filter((p) => isPrelaunchProduct(p.status));
}
